<!-- 发起弹窗 -->
<template>
  <div>
    <el-dialog
      title="手动代付"
      :visible="isShowCreateTransferDialog"
      width="30%"
      top="4vh"
      :close-on-click-modal="false"
      @close="handleDialog"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="appId" label-width="120px" prop="appId">
          <el-input
            size="small"
            type="text"
            v-model="form.appId"
            placeholder="请输入 appId"
          ></el-input>
        </el-form-item>

        <el-form-item label="signKey" label-width="120px" prop="signKey">
          <el-input
            size="small"
            type="text"
            v-model="form.signKey"
            placeholder="请输入 signKey"
          ></el-input>
        </el-form-item>

        <el-form-item label="amount(单位分)" label-width="120px" prop="amount">
          <el-input
            size="small"
            type="text"
            v-model="form.amount"
            placeholder="请输入 amount"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="merchantOrderId"
          label-width="120px"
          prop="merchantOrderId"
        >
          <el-input
            size="small"
            type="text"
            v-model="form.merchantOrderId"
            placeholder="请输入 merchantOrderId"
          ></el-input>

          <el-button type="primary" size="mini" plain @click="genMerOrderId">
            生成
          </el-button>
        </el-form-item>

        <el-form-item label="notifyUrl" label-width="120px" prop="notifyUrl">
          <el-input
            size="small"
            type="text"
            v-model="form.notifyUrl"
            placeholder="请输入notifyUrl"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="accountType"
          label-width="120px"
          prop="accountType"
        >
          <el-input
            size="small"
            type="text"
            v-model="form.accountType"
            placeholder="请输入 EMAIL/PHONE/CPF/CNPJ/RANDOM"
          ></el-input>
        </el-form-item>

        <el-form-item label="accountNum" label-width="120px" prop="accountNum">
          <el-input
            size="small"
            type="text"
            v-model="form.accountNum"
            placeholder="请输入 pix账号"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="customerName"
          label-width="120px"
          prop="customerName"
        >
          <el-input
            size="small"
            type="text"
            v-model="form.customerName"
            placeholder="请输入 customerName"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="customerCert"
          label-width="120px"
          prop="customerCert"
        >
          <el-input
            size="small"
            type="text"
            v-model="form.customerCert"
            placeholder="请输入 cpf/cnpj号"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
let Base64 = require('js-base64').Base64

export default {
  props: {
    isShowCreateTransferDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        appId: '',
        signKey: '',
        amount: '',
        merchantOrderId: '',
        notifyUrl: '',
        accountType: '',
        accountNum: '',
        customerName: '',
        customerCert: '',
      },
      rules: {},
    }
  },
  methods: {
    handleDialog() {
      this.$refs['form'].resetFields()
      this.form = {
        appId: '',
        signKey: '',
        amount: '',
        merchantOrderId: '',
        notifyUrl: '',
        accountType: '',
        accountNum: '',
        customerName: '',
        customerCert: '',
      }
      this.$emit('update:isShowCreateTransferDialog', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const params = {
            ...this.form,
          }

          var base64Str = Base64.encode(params.appId + ':' + params.signKey)
          console.log(base64Str)

          const url = '/open-api/pay/transfer'
          let testRequest = new Request(url, {
            method: 'post',
            headers: {
              'Content-Type': 'application/json;charset=utf-8;',
              Authorization: 'Basic ' + base64Str,
            },
            body: JSON.stringify(params),
          })
          fetch(testRequest).then(response => {
            let result = response.json()
            result.then(res => {
              console.log(res)
              if (res.code === 200 && res.status === '99') {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
                this.$emit('update:isShowCreateTransferDialog', false)
                this.$bus.$emit('refresh') //通知刷新
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
          })
        }
      })
    },

    genMerOrderId() {
      var uuid = 'xxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 12) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8
          return v.toString(12)
        }
      )
      var genId = 'df' + uuid
      console.log(genId)

      this.form.merchantOrderId = genId

      return genId
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 0px solid #e4e7ed;
}

::v-deep .el-form-item {
  margin-bottom: 1px;
}

::v-deep .el-form-item .el-input {
  width: 330px;
}
</style>